export default "__VITE_ASSET__BF1BE4fQ__"